export const IDENTITY_CONFIG = {
  authority:
    'https://auth.scribonline.com/development/config/externalview.scribonline.com', //(string): The URL of the OIDC provider.
  client_id: 'viewer.scribonline.com/external.local', //(string): Your client application's identifier as registered with the OIDC provider.
  redirect_uri: `${process.env.REACT_APP_HOST_URL}/signin-callback.html`, //The URI of your client application to receive a response from the OIDC provider.
  loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
  post_logout_redirect_uri: `${process.env.REACT_APP_HOST_URL}/external`, // (string): The OIDC post-logout redirect URI.
  response_type: 'code',
  scope: 'openid profile email api',
  revokeAccessTokenOnSignout: true
};
export const IDENTITY_CONFIG_MODERN = {
  authority:
    'https://docmanagement.parchment.com/v1/api/archive/external/oauth', //(string): The URL of the OIDC provider.
  client_id: 'viewer.scribonline.com/external.local.modern', //(string): Your client application's identifier as registered with the OIDC provider.
  redirect_uri: `${process.env.REACT_APP_HOST_URL}/signin-callback.html`, //The URI of your client application to receive a response from the OIDC provider.
  loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
  post_logout_redirect_uri: `${
    process.env.REACT_APP_HOST_URL
  }/external?newchive=true`, // (string): The OIDC post-logout redirect URI.
  response_type: 'code',
  scope: 'openid profile email api',
  revokeAccessTokenOnSignout: true
};
